import { Head, useForm, usePage } from "@inertiajs/react";
import { SubmitEvent } from "react";
import { Flex } from "@radix-ui/themes";
import TeamForm from "./_form";
import SetupForEventCallout, { setupPath } from "@/shared/events/SetupForEventCallout";
import { CurrentUser, TeamFormData } from "@/types/shared";
import { TeamParticipantsNewProps } from "@/types/team_participants_new";

export default function NewTeamParticipant({ errors, event_id, event_name }: TeamParticipantsNewProps) {
  const { currentUser } = usePage<{ currentUser: CurrentUser }>().props;

  const { data, setData, post, processing } = useForm<TeamFormData>({
    participant: {
      name: "",
      location: "",
      email: "",
      phone_number: "",
      instagram: "",
    },
    team: {
      description: "",
      logo: null,
      photos: [],
    },
    invited_emails: [],
  });

  const handleSubmit = (e: SubmitEvent) => {
    e.preventDefault();
    post(setupPath("/team_participant", { event_id, event_name }), { forceFormData: true });
  };

  return (
    <>
      <Head title="Create Team" />
      <div style={{ maxWidth: 680, margin: "0 auto", padding: "2rem 1.5rem 4rem" }}>
        <Flex direction="column" gap="4">
          <SetupForEventCallout event_id={event_id} event_name={event_name} />
          <TeamForm
            data={data}
            setData={setData}
            onSubmit={handleSubmit}
            processing={processing}
            errors={errors}
            currentUserEmail={currentUser?.email ?? ""}
            title="Create a Team"
            submitLabel="Create Team"
          />
        </Flex>
      </div>
    </>
  );
}
